// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
  2. Remove default margins and padding
  3. Reset all borders.
*/
*,
::after,
::before,
::backdrop,
::file-selector-button {
  box-sizing: border-box; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 2 */
  border: 0 solid; /* 3 */
}

/*
  1. Use a consistent sensible line-height in all browsers.
  2. Prevent adjustments of font size after orientation changes in iOS.
  3. Use a more readable tab size.
  4. Use the user's configured \`sans\` font-family by default.
  5. Use the user's configured \`sans\` font-feature-settings by default.
  6. Use the user's configured \`sans\` font-variation-settings by default.
  7. Disable tap highlights on iOS.
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  tab-size: 4; /* 3 */
  font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"); /* 4 */
  font-feature-settings: var(--default-font-feature-settings, normal); /* 5 */
  font-variation-settings: var(--default-font-variation-settings, normal); /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
  Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  line-height: inherit;
}

/*
  1. Add the correct height in Firefox.
  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
  3. Reset the default border style to a 1px solid border.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
  Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}

/*
  Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
  Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  -webkit-text-decoration: inherit;
  text-decoration: inherit;
}

/*
  Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/*
  1. Use the user's configured \`mono\` font-family by default.
  2. Use the user's configured \`mono\` font-feature-settings by default.
  3. Use the user's configured \`mono\` font-variation-settings by default.
  4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace); /* 4 */
  font-feature-settings: var(--default-mono-font-feature-settings, normal); /* 5 */
  font-variation-settings: var(--default-mono-font-variation-settings, normal); /* 6 */
  font-size: 1em; /* 4 */
}

/*
  Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/*
  Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
  3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
  Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}

/*
  Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}

/*
  Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}

/*
  Make lists unstyled by default.
*/
ol,
ul,
menu {
  list-style: none;
}

/*
  1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
  2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
      This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}

/*
  1. Inherit font styles in all browsers.
  2. Remove border radius in all browsers.
  3. Remove background color in all browsers.
  4. Ensure consistent opacity for disabled states in all browsers.
*/
button,
input,
select,
optgroup,
textarea,
::file-selector-button {
  font: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  border-radius: 0; /* 2 */
  background-color: transparent; /* 3 */
  opacity: 1; /* 4 */
}

/*
  Restore default font weight.
*/
:where(select:is([multiple], [size])) optgroup {
  font-weight: bolder;
}

/*
  Restore indentation.
*/
:where(select:is([multiple], [size])) optgroup option {
  padding-inline-start: 20px;
}

/*
  Restore space after button.
*/
::file-selector-button {
  margin-inline-end: 4px;
}

/*
  1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
  2. Set the default placeholder color to a semi-transparent version of the current text color.
*/
::placeholder {
  opacity: 1; /* 1 */
  color: color-mix(in oklab, currentColor 50%, transparent); /* 2 */
}

/*
  Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}

/*
  Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
  1. Ensure date/time inputs have the same height when empty in iOS Safari.
  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.
*/
::-webkit-date-and-time-value {
  min-height: 1lh; /* 1 */
  text-align: inherit; /* 2 */
}

/*
  Prevent height from changing on date/time inputs in macOS Safari when the input is set to \`display: block\`.
*/
::-webkit-datetime-edit {
  display: inline-flex;
}

/*
  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.
*/
::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-datetime-edit,
::-webkit-datetime-edit-year-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-minute-field,
::-webkit-datetime-edit-second-field,
::-webkit-datetime-edit-millisecond-field,
::-webkit-datetime-edit-meridiem-field {
  padding-block: 0;
}

/*
  Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}

/*
  Correct the inability to style the border radius in iOS Safari.
*/
button,
input:where([type=button], [type=reset], [type=submit]),
::file-selector-button {
  appearance: button;
}

/*
  Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
  Make elements with the HTML hidden attribute stay hidden by default.
*/
[hidden]:where(:not([hidden=until-found])) {
  display: none !important;
}

.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none{
  pointer-events: none;
}

.visible{
  visibility: visible;
}

.collapse{
  visibility: collapse;
}

.static{
  position: static;
}

.fixed{
  position: fixed;
}

.absolute{
  position: absolute;
}

.relative{
  position: relative;
}

.sticky{
  position: sticky;
}

.inset-0{
  inset: 0px;
}

.inset-y-0{
  top: 0px;
  bottom: 0px;
}

.left-0{
  left: 0px;
}

.left-1{
  left: 0.25rem;
}

.left-4{
  left: 1rem;
}

.right-0{
  right: 0px;
}

.right-1{
  right: 0.25rem;
}

.right-10{
  right: 2.5rem;
}

.right-4{
  right: 1rem;
}

.top-0{
  top: 0px;
}

.top-1{
  top: 0.25rem;
}

.top-12{
  top: 3rem;
}

.top-4{
  top: 1rem;
}

.top-\\[55\\%\\]{
  top: 55%;
}

.z-10{
  z-index: 10;
}

.z-50{
  z-index: 50;
}

.z-\\[9999\\]{
  z-index: 9999;
}

.col-span-2{
  grid-column: span 2 / span 2;
}

.col-span-3{
  grid-column: span 3 / span 3;
}

.m-4{
  margin: 1rem;
}

.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-auto{
  margin-left: auto;
  margin-right: auto;
}

.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mb-1{
  margin-bottom: 0.25rem;
}

.mb-10{
  margin-bottom: 2.5rem;
}

.mb-2{
  margin-bottom: 0.5rem;
}

.mb-3{
  margin-bottom: 0.75rem;
}

.mb-4{
  margin-bottom: 1rem;
}

.mb-5{
  margin-bottom: 1.25rem;
}

.mb-6{
  margin-bottom: 1.5rem;
}

.mb-8{
  margin-bottom: 2rem;
}

.ml-2{
  margin-left: 0.5rem;
}

.ml-3{
  margin-left: 0.75rem;
}

.ml-4{
  margin-left: 1rem;
}

.ml-6{
  margin-left: 1.5rem;
}

.ml-8{
  margin-left: 2rem;
}

.ml-\\[320px\\]{
  margin-left: 320px;
}

.mr-1{
  margin-right: 0.25rem;
}

.mr-2{
  margin-right: 0.5rem;
}

.mr-20{
  margin-right: 5rem;
}

.mr-3{
  margin-right: 0.75rem;
}

.mr-8{
  margin-right: 2rem;
}

.mt-1{
  margin-top: 0.25rem;
}

.mt-10{
  margin-top: 2.5rem;
}

.mt-11{
  margin-top: 2.75rem;
}

.mt-16{
  margin-top: 4rem;
}

.mt-2{
  margin-top: 0.5rem;
}

.mt-20{
  margin-top: 5rem;
}

.mt-3{
  margin-top: 0.75rem;
}

.mt-4{
  margin-top: 1rem;
}

.mt-5{
  margin-top: 1.25rem;
}

.mt-6{
  margin-top: 1.5rem;
}

.block{
  display: block;
}

.inline-block{
  display: inline-block;
}

.inline{
  display: inline;
}

.flex{
  display: flex;
}

.inline-flex{
  display: inline-flex;
}

.table{
  display: table;
}

.grid{
  display: grid;
}

.hidden{
  display: none;
}

.h-10{
  height: 2.5rem;
}

.h-12{
  height: 3rem;
}

.h-20{
  height: 5rem;
}

.h-4{
  height: 1rem;
}

.h-5{
  height: 1.25rem;
}

.h-6{
  height: 1.5rem;
}

.h-64{
  height: 16rem;
}

.h-\\[100\\%\\]{
  height: 100%;
}

.h-\\[100px\\]{
  height: 100px;
}

.h-\\[33px\\]{
  height: 33px;
}

.h-\\[40px\\]{
  height: 40px;
}

.h-\\[44px\\]{
  height: 44px;
}

.h-\\[49px\\]{
  height: 49px;
}

.h-\\[660px\\]{
  height: 660px;
}

.h-\\[calc\\(100vh-300px\\)\\]{
  height: calc(100vh - 300px);
}

.h-full{
  height: 100%;
}

.h-px{
  height: 1px;
}

.h-screen{
  height: 100vh;
}

.max-h-48{
  max-height: 12rem;
}

.max-h-60{
  max-height: 15rem;
}

.max-h-\\[600px\\]{
  max-height: 600px;
}

.min-h-full{
  min-height: 100%;
}

.min-h-screen{
  min-height: 100vh;
}

.w-0{
  width: 0px;
}

.w-0\\.5{
  width: 0.125rem;
}

.w-1\\/2{
  width: 50%;
}

.w-1\\/3{
  width: 33.333333%;
}

.w-1\\/4{
  width: 25%;
}

.w-10{
  width: 2.5rem;
}

.w-12{
  width: 3rem;
}

.w-16{
  width: 4rem;
}

.w-2\\/3{
  width: 66.666667%;
}

.w-20{
  width: 5rem;
}

.w-24{
  width: 6rem;
}

.w-3\\/4{
  width: 75%;
}

.w-32{
  width: 8rem;
}

.w-36{
  width: 9rem;
}

.w-4{
  width: 1rem;
}

.w-48{
  width: 12rem;
}

.w-5{
  width: 1.25rem;
}

.w-6{
  width: 1.5rem;
}

.w-8{
  width: 2rem;
}

.w-80{
  width: 20rem;
}

.w-\\[100px\\]{
  width: 100px;
}

.w-\\[109px\\]{
  width: 109px;
}

.w-\\[136px\\]{
  width: 136px;
}

.w-\\[140px\\]{
  width: 140px;
}

.w-\\[220px\\]{
  width: 220px;
}

.w-\\[375px\\]{
  width: 375px;
}

.w-\\[394px\\]{
  width: 394px;
}

.w-\\[40px\\]{
  width: 40px;
}

.w-\\[74px\\]{
  width: 74px;
}

.w-full{
  width: 100%;
}

.min-w-\\[300px\\]{
  min-width: 300px;
}

.min-w-full{
  min-width: 100%;
}

.max-w-2xl{
  max-width: 42rem;
}

.max-w-4xl{
  max-width: 56rem;
}

.max-w-\\[150px\\]{
  max-width: 150px;
}

.max-w-\\[333px\\]{
  max-width: 333px;
}

.max-w-\\[340px\\]{
  max-width: 340px;
}

.max-w-\\[496px\\]{
  max-width: 496px;
}

.max-w-\\[555px\\]{
  max-width: 555px;
}

.max-w-\\[700px\\]{
  max-width: 700px;
}

.max-w-\\[800px\\]{
  max-width: 800px;
}

.max-w-lg{
  max-width: 32rem;
}

.max-w-md{
  max-width: 28rem;
}

.max-w-sm{
  max-width: 24rem;
}

.max-w-xl{
  max-width: 36rem;
}

.max-w-xs{
  max-width: 20rem;
}

.flex-1{
  flex: 1 1;
}

.shrink{
  flex-shrink: 1;
}

.flex-grow{
  flex-grow: 1;
}

.table-fixed{
  table-layout: fixed;
}

.border-collapse{
  border-collapse: collapse;
}

.border-separate{
  border-collapse: separate;
}

.border-spacing-0{
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}

.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[42px\\]{
  --tw-translate-x: 42px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}

.animate-spin{
  animation: spin 1s linear infinite;
}

.cursor-not-allowed{
  cursor: not-allowed;
}

.cursor-pointer{
  cursor: pointer;
}

.select-none{
  -webkit-user-select: none;
          user-select: none;
}

.resize{
  resize: both;
}

.list-inside{
  list-style-position: inside;
}

.list-disc{
  list-style-type: disc;
}

.list-none{
  list-style-type: none;
}

.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.flex-row{
  flex-direction: row;
}

.flex-col{
  flex-direction: column;
}

.flex-wrap{
  flex-wrap: wrap;
}

.place-items-center{
  place-items: center;
}

.items-start{
  align-items: flex-start;
}

.items-end{
  align-items: flex-end;
}

.items-center{
  align-items: center;
}

.justify-start{
  justify-content: flex-start;
}

.justify-end{
  justify-content: flex-end;
}

.justify-center{
  justify-content: center;
}

.justify-between{
  justify-content: space-between;
}

.justify-items-stretch{
  justify-items: stretch;
}

.gap-1{
  gap: 0.25rem;
}

.gap-1\\.5{
  gap: 0.375rem;
}

.gap-2{
  gap: 0.5rem;
}

.gap-3{
  gap: 0.75rem;
}

.gap-4{
  gap: 1rem;
}

.gap-5{
  gap: 1.25rem;
}

.gap-6{
  gap: 1.5rem;
}

.gap-8{
  gap: 2rem;
}

.gap-y-4{
  row-gap: 1rem;
}

.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.divide-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}

.overflow-auto{
  overflow: auto;
}

.overflow-hidden{
  overflow: hidden;
}

.overflow-x-auto{
  overflow-x: auto;
}

.overflow-y-auto{
  overflow-y: auto;
}

.overflow-y-scroll{
  overflow-y: scroll;
}

.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitespace-nowrap{
  white-space: nowrap;
}

.break-words{
  overflow-wrap: break-word;
}

.rounded{
  border-radius: 0.25rem;
}

.rounded-\\[10px\\]{
  border-radius: 10px;
}

.rounded-\\[30px\\]{
  border-radius: 30px;
}

.rounded-\\[3px\\]{
  border-radius: 3px;
}

.rounded-\\[6px\\]{
  border-radius: 6px;
}

.rounded-full{
  border-radius: 9999px;
}

.rounded-lg{
  border-radius: 0.5rem;
}

.rounded-md{
  border-radius: 0.375rem;
}

.rounded-sm{
  border-radius: 0.125rem;
}

.rounded-xl{
  border-radius: 0.75rem;
}

.rounded-r-\\[30px\\]{
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.rounded-t-lg{
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.border{
  border-width: 1px;
}

.border-2{
  border-width: 2px;
}

.border-\\[0\\.8px\\]{
  border-width: 0.8px;
}

.border-\\[1\\.5px\\]{
  border-width: 1.5px;
}

.border-\\[1px\\]{
  border-width: 1px;
}

.border-b{
  border-bottom-width: 1px;
}

.border-r{
  border-right-width: 1px;
}

.border-r-\\[1\\.5px\\]{
  border-right-width: 1.5px;
}

.border-t{
  border-top-width: 1px;
}

.border-dashed{
  border-style: dashed;
}

.border-\\[\\#151515\\]{
  --tw-border-opacity: 1;
  border-color: rgb(21 21 21 / var(--tw-border-opacity));
}

.border-\\[\\#272727\\]{
  --tw-border-opacity: 1;
  border-color: rgb(39 39 39 / var(--tw-border-opacity));
}

.border-\\[\\#4F4F4F\\]{
  --tw-border-opacity: 1;
  border-color: rgb(79 79 79 / var(--tw-border-opacity));
}

.border-\\[\\#747474\\]{
  --tw-border-opacity: 1;
  border-color: rgb(116 116 116 / var(--tw-border-opacity));
}

.border-\\[\\#FF5336\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 83 54 / var(--tw-border-opacity));
}

.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}

.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}

.border-gray-800{
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}

.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}

.border-postman-gray-light{
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}

.border-postman-gray-medium{
  --tw-border-opacity: 1;
  border-color: rgb(108 117 125 / var(--tw-border-opacity));
}

.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}

.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-opacity-30{
  --tw-border-opacity: 0.3;
}

.bg-\\[\\#0043CE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(0 67 206 / var(--tw-bg-opacity));
}

.bg-\\[\\#151515\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 21 / var(--tw-bg-opacity));
}

.bg-\\[\\#181818\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 24 / var(--tw-bg-opacity));
}

.bg-\\[\\#1E1E1E\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity));
}

.bg-\\[\\#262626\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}

.bg-\\[\\#2651D1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 81 209 / var(--tw-bg-opacity));
}

.bg-\\[\\#272727\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 39 / var(--tw-bg-opacity));
}

.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity));
}

.bg-\\[\\#FF5336\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 83 54 / var(--tw-bg-opacity));
}

.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}

.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}

.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}

.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}

.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}

.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}

.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}

.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}

.bg-postman-blue{
  --tw-bg-opacity: 1;
  background-color: rgb(0 118 255 / var(--tw-bg-opacity));
}

.bg-postman-gray-light{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.bg-postman-orange{
  --tw-bg-opacity: 1;
  background-color: rgb(255 108 55 / var(--tw-bg-opacity));
}

.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}

.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}

.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}

.bg-opacity-20{
  --tw-bg-opacity: 0.2;
}

.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}

.bg-custom-gradient{
  background-image: linear-gradient(107.3deg, #6E38E0 13.39%, #FF5F36 77.64%);
}

.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}

.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.from-\\[\\#6E38E0\\]{
  --tw-gradient-from: #6E38E0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(110 56 224 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.via-pink-500{
  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.to-\\[\\#FF5F36\\]{
  --tw-gradient-to: #FF5F36 var(--tw-gradient-to-position);
}

.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}

.object-contain{
  object-fit: contain;
}

.p-1{
  padding: 0.25rem;
}

.p-2{
  padding: 0.5rem;
}

.p-3{
  padding: 0.75rem;
}

.p-4{
  padding: 1rem;
}

.p-6{
  padding: 1.5rem;
}

.p-8{
  padding: 2rem;
}

.p-9{
  padding: 2.25rem;
}

.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}

.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}

.pb-2{
  padding-bottom: 0.5rem;
}

.pl-10{
  padding-left: 2.5rem;
}

.pl-12{
  padding-left: 3rem;
}

.pl-4{
  padding-left: 1rem;
}

.pr-3{
  padding-right: 0.75rem;
}

.pr-4{
  padding-right: 1rem;
}

.pr-8{
  padding-right: 2rem;
}

.pt-2{
  padding-top: 0.5rem;
}

.text-left{
  text-align: left;
}

.text-center{
  text-align: center;
}

.align-middle{
  vertical-align: middle;
}

.font-mono{
  font-family: Courier, monospace;
}

.font-sans{
  font-family: Inter, Roboto, Arial, sans-serif;
}

.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-5xl{
  font-size: 3rem;
  line-height: 1;
}

.text-\\[12px\\]{
  font-size: 12px;
}

.text-\\[14px\\]{
  font-size: 14px;
}

.text-\\[15px\\]{
  font-size: 15px;
}

.text-\\[16px\\]{
  font-size: 16px;
}

.text-\\[18px\\]{
  font-size: 18px;
}

.text-\\[20px\\]{
  font-size: 20px;
}

.text-\\[24px\\]{
  font-size: 24px;
}

.text-\\[40px\\]{
  font-size: 40px;
}

.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold{
  font-weight: 700;
}

.font-extralight{
  font-weight: 200;
}

.font-light{
  font-weight: 300;
}

.font-medium{
  font-weight: 500;
}

.font-normal{
  font-weight: 400;
}

.font-semibold{
  font-weight: 600;
}

.uppercase{
  text-transform: uppercase;
}

.lowercase{
  text-transform: lowercase;
}

.capitalize{
  text-transform: capitalize;
}

.italic{
  font-style: italic;
}

.leading-10{
  line-height: 2.5rem;
}

.leading-5{
  line-height: 1.25rem;
}

.leading-6{
  line-height: 1.5rem;
}

.leading-7{
  line-height: 1.75rem;
}

.text-\\[\\#151515\\]{
  --tw-text-opacity: 1;
  color: rgb(21 21 21 / var(--tw-text-opacity));
}

.text-\\[\\#1E1E1E\\]{
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / var(--tw-text-opacity));
}

.text-\\[\\#2550D1\\]{
  --tw-text-opacity: 1;
  color: rgb(37 80 209 / var(--tw-text-opacity));
}

.text-\\[\\#696F79\\]{
  --tw-text-opacity: 1;
  color: rgb(105 111 121 / var(--tw-text-opacity));
}

.text-\\[\\#8692A6\\]{
  --tw-text-opacity: 1;
  color: rgb(134 146 166 / var(--tw-text-opacity));
}

.text-\\[\\#ADA7A7\\]{
  --tw-text-opacity: 1;
  color: rgb(173 167 167 / var(--tw-text-opacity));
}

.text-\\[\\#FF5336\\]{
  --tw-text-opacity: 1;
  color: rgb(255 83 54 / var(--tw-text-opacity));
}

.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}

.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}

.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}

.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}

.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}

.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}

.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}

.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}

.text-postman-blue{
  --tw-text-opacity: 1;
  color: rgb(0 118 255 / var(--tw-text-opacity));
}

.text-postman-gray-dark{
  --tw-text-opacity: 1;
  color: rgb(52 58 64 / var(--tw-text-opacity));
}

.text-postman-gray-medium{
  --tw-text-opacity: 1;
  color: rgb(108 117 125 / var(--tw-text-opacity));
}

.text-postman-green{
  --tw-text-opacity: 1;
  color: rgb(40 167 69 / var(--tw-text-opacity));
}

.text-postman-red{
  --tw-text-opacity: 1;
  color: rgb(215 58 73 / var(--tw-text-opacity));
}

.text-postman-yellow{
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}

.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}

.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}

.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}

.underline{
  text-decoration-line: underline;
}

.underline-offset-2{
  text-underline-offset: 2px;
}

.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}

.opacity-0{
  opacity: 0;
}

.opacity-25{
  opacity: 0.25;
}

.opacity-70{
  opacity: 0.7;
}

.opacity-75{
  opacity: 0.75;
}

.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-custom{
  --tw-shadow: 2px 9px 10px 7.8px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 2px 9px 10px 7.8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline{
  outline-style: solid;
}

.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.backdrop-filter{
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200{
  transition-duration: 200ms;
}

.duration-300{
  transition-duration: 300ms;
}

.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
* {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
*::-webkit-scrollbar {
  width: 0.3rem;
  display: none;
}
*::-webkit-scrollbar-track {
  background: #d9d9d9;
}
*::-webkit-scrollbar-thumb {
  background: black;
}
*::-webkit-scrollbar-thumb:hover {
  background: black;
  cursor: pointer;
}

.urbanist-font {
  font-family: "Urbanist", sans-serif;
  font-optical-sizing: auto;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-r-0:last-child{
  border-right-width: 0px;
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-black:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#272727\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 39 / var(--tw-bg-opacity));
}

.hover\\:bg-black:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}

.hover\\:bg-orange-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}

.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}

.hover\\:bg-postman-gray-light:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}

.hover\\:hover\\:bg-gray-300:hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.hover\\:bg-opacity-90:hover{
  --tw-bg-opacity: 0.9;
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.hover\\:text-postman-gray-dark:hover{
  --tw-text-opacity: 1;
  color: rgb(52 58 64 / var(--tw-text-opacity));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-black:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
}

.focus\\:ring-orange-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity));
}

.focus\\:ring-postman-blue:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 118 255 / var(--tw-ring-opacity));
}

.focus\\:ring-postman-orange:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 108 55 / var(--tw-ring-opacity));
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.group[open] .group-open\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

@media (min-width: 768px){
  .md\\:w-1\\/2{
    width: 50%;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px){
  .lg\\:block{
    display: block;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .lg\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/tailwindcss/preflight.css","webpack://./src/App.style.scss","webpack://./node_modules/tailwindcss/utilities.css"],"names":[],"mappings":"AAAA;;;;CAAA;AAMA;;;;;EAKE,sBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;ACCF;;ADEA;;;;;;;;CAAA;AAUA;;EAEE,gBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;EACA,WAAA,EAAA,MAAA;EACA,2JAAA,EASG,MAAA;EACH,mEAAA,EAAA,MAAA;EACA,uEAAA,EAAA,MAAA;EACA,wCAAA,EAAA,MAAA;ACTF;;ADYA;;CAAA;AAIA;EACE,oBAAA;ACVF;;ADaA;;;;CAAA;AAMA;EACE,SAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,qBAAA,EAAA,MAAA;ACXF;;ADcA;;CAAA;AAIA;EACE,yCAAA;EACA,iCAAA;ACZF;;ADeA;;CAAA;AAIA;;;;;;EAME,kBAAA;EACA,oBAAA;ACbF;;ADgBA;;CAAA;AAIA;EACE,cAAA;EACA,gCAAA;EACA,wBAAA;ACdF;;ADiBA;;CAAA;AAIA;;EAEE,mBAAA;ACfF;;ADkBA;;;;;CAAA;AAOA;;;;EAIE,gJAAA,EAUG,MAAA;EACH,wEAAA,EAAA,MAAA;EACA,4EAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AC1BF;;AD6BA;;CAAA;AAIA;EACE,cAAA;AC3BF;;AD8BA;;CAAA;AAIA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AC5BF;;AD+BA;EACE,eAAA;AC5BF;;AD+BA;EACE,WAAA;AC5BF;;AD+BA;;;;CAAA;AAMA;EACE,cAAA,EAAA,MAAA;EACA,qBAAA,EAAA,MAAA;EACA,yBAAA,EAAA,MAAA;AC7BF;;ADgCA;;CAAA;AAIA;EACE,aAAA;AC9BF;;ADiCA;;CAAA;AAIA;EACE,wBAAA;AC/BF;;ADkCA;;CAAA;AAIA;EACE,kBAAA;AChCF;;ADmCA;;CAAA;AAIA;;;EAGE,gBAAA;ACjCF;;ADoCA;;;;CAAA;AAMA;;;;;;;;EAQE,cAAA,EAAA,MAAA;EACA,sBAAA,EAAA,MAAA;AClCF;;ADqCA;;CAAA;AAIA;;EAEE,eAAA;EACA,YAAA;ACnCF;;ADsCA;;;;;CAAA;AAOA;;;;;;EAME,aAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;EACA,gCAAA,EAAA,MAAA;EACA,uBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,gBAAA,EAAA,MAAA;EACA,6BAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;ACpCF;;ADuCA;;CAAA;AAIA;EACE,mBAAA;ACrCF;;ADwCA;;CAAA;AAIA;EACE,0BAAA;ACtCF;;ADyCA;;CAAA;AAIA;EACE,sBAAA;ACvCF;;AD0CA;;;CAAA;AAKA;EACE,UAAA,EAAA,MAAA;EACA,yDAAA,EAAA,MAAA;ACxCF;;AD2CA;;CAAA;AAIA;EACE,gBAAA;ACzCF;;AD4CA;;CAAA;AAIA;EACE,wBAAA;AC1CF;;AD6CA;;;CAAA;AAKA;EACE,eAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AC3CF;;AD8CA;;CAAA;AAIA;EACE,oBAAA;AC5CF;;AD+CA;;CAAA;AAIA;EACE,UAAA;AC7CF;;ADgDA;;;;;;;;;EASE,gBAAA;AC7CF;;ADgDA;;CAAA;AAIA;EACE,gBAAA;AC9CF;;ADiDA;;CAAA;AAIA;;;EAGE,kBAAA;AC/CF;;ADkDA;;CAAA;AAIA;;EAEE,YAAA;AChDF;;ADmDA;;CAAA;AAIA;EACE,wBAAA;ACjDF;;AC5UA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,QAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,iBAAA;EAAA;AAAA;;AAAA;EAAA,iBAAA;EAAA;AAAA;;AAAA;EAAA,gBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;IAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,yBAAA;UAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,uDAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,oDAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;;AAAA;EAAA,uBAAA;EAAA,4DAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,kEAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,6BAAA;EAAA;AAAA;;AAAA;EAAA,8BAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;;AAAA;EAAA,qEAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,iBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,iBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,iBAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA,eAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA,mBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,2BAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,0EAAA;EAAA,8FAAA;EAAA;AAAA;;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;;AAAA;EAAA,mDAAA;EAAA,8DAAA;EAAA;AAAA;;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;;AAAA;EAAA,6EAAA;EAAA,iGAAA;EAAA;AAAA;;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA,+QAAA;UAAA;AAAA;;AAAA;EAAA,gKAAA;EAAA,wJAAA;EAAA,iLAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,+BAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;;AAAA;EAAA;AAAA;ADKA;EAME,UAAA;EAKA,WAAA;EAKA,oBAAA;AA8TF;AA7UE;EACE,aAAA;EACA,aAAA;AA+UJ;AA3UE;EACE,mBAAA;AA6UJ;AAzUE;EACE,iBAAA;AA2UJ;AAvUE;EACE,iBAAA;EACA,eAAA;AAyUJ;;AArUA;EACE,mCAAA;EACA,yBAAA;AAwUF;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,sBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,kBCsWA;EDtWA;ACsWA;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,6ECsWA;EDtWA,iGCsWA;EDtWA;ACsWA;;ADtWA;EAAA,gFCsWA;EDtWA,oGCsWA;EDtWA;ACsWA;;ADtWA;EAAA,sBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,sBCsWA;EDtWA;ACsWA;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA,8BCsWA;EDtWA;ACsWA;;ADtWA;EAAA,2GCsWA;EDtWA,yGCsWA;EDtWA;ACsWA;;ADtWA;EAAA,2GCsWA;EDtWA,yGCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA,oBCsWA;EDtWA;ACsWA;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA,mBCsWA;EDtWA;ACsWA;;ADtWA;EAAA;ACsWA;;ADtWA;EAAA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA,oBCsWA;IDtWA;ECsWA;AAAA;;ADtWA;EAAA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;EDtWA;IAAA;ECsWA;AAAA","sourcesContent":["/*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n*,\n::after,\n::before,\n::backdrop,\n::file-selector-button {\n  box-sizing: border-box; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 2 */\n  border: 0 solid; /* 3 */\n}\n\n/*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\nhtml,\n:host {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  tab-size: 4; /* 3 */\n  font-family: var(\n    --default-font-family,\n    ui-sans-serif,\n    system-ui,\n    sans-serif,\n    'Apple Color Emoji',\n    'Segoe UI Emoji',\n    'Segoe UI Symbol',\n    'Noto Color Emoji'\n  ); /* 4 */\n  font-feature-settings: var(--default-font-feature-settings, normal); /* 5 */\n  font-variation-settings: var(--default-font-variation-settings, normal); /* 6 */\n  -webkit-tap-highlight-color: transparent; /* 7 */\n}\n\n/*\n  Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  line-height: inherit;\n}\n\n/*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n}\n\n/*\n  Remove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  -webkit-text-decoration: inherit;\n  text-decoration: inherit;\n}\n\n/*\n  Add the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: var(\n    --default-mono-font-family,\n    ui-monospace,\n    SFMono-Regular,\n    Menlo,\n    Monaco,\n    Consolas,\n    'Liberation Mono',\n    'Courier New',\n    monospace\n  ); /* 4 */\n  font-feature-settings: var(--default-mono-font-feature-settings, normal); /* 5 */\n  font-variation-settings: var(--default-mono-font-variation-settings, normal); /* 6 */\n  font-size: 1em; /* 4 */\n}\n\n/*\n  Add the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\n  Add the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\n  Make lists unstyled by default.\n*/\n\nol,\nul,\nmenu {\n  list-style: none;\n}\n\n/*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\nbutton,\ninput,\nselect,\noptgroup,\ntextarea,\n::file-selector-button {\n  font: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  letter-spacing: inherit; /* 1 */\n  color: inherit; /* 1 */\n  border-radius: 0; /* 2 */\n  background-color: transparent; /* 3 */\n  opacity: 1; /* 4 */\n}\n\n/*\n  Restore default font weight.\n*/\n\n:where(select:is([multiple], [size])) optgroup {\n  font-weight: bolder;\n}\n\n/*\n  Restore indentation.\n*/\n\n:where(select:is([multiple], [size])) optgroup option {\n  padding-inline-start: 20px;\n}\n\n/*\n  Restore space after button.\n*/\n\n::file-selector-button {\n  margin-inline-end: 4px;\n}\n\n/*\n  1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n  2. Set the default placeholder color to a semi-transparent version of the current text color.\n*/\n\n::placeholder {\n  opacity: 1; /* 1 */\n  color: color-mix(in oklab, currentColor 50%, transparent); /* 2 */\n}\n\n/*\n  Prevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n::-webkit-date-and-time-value {\n  min-height: 1lh; /* 1 */\n  text-align: inherit; /* 2 */\n}\n\n/*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n::-webkit-datetime-edit {\n  display: inline-flex;\n}\n\n/*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n::-webkit-datetime-edit-fields-wrapper {\n  padding: 0;\n}\n\n::-webkit-datetime-edit,\n::-webkit-datetime-edit-year-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-minute-field,\n::-webkit-datetime-edit-second-field,\n::-webkit-datetime-edit-millisecond-field,\n::-webkit-datetime-edit-meridiem-field {\n  padding-block: 0;\n}\n\n/*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\nbutton,\ninput:where([type='button'], [type='reset'], [type='submit']),\n::file-selector-button {\n  appearance: button;\n}\n\n/*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n[hidden]:where(:not([hidden='until-found'])) {\n  display: none !important;\n}\n","@import \"tailwindcss/preflight\";\n@import \"tailwindcss/utilities\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap\");\n\n* {\n  &::-webkit-scrollbar {\n    width: 0.3rem;\n    display: none;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #d9d9d9;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: black;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: black;\n    cursor: pointer;\n  }\n}\n\n.urbanist-font {\n  font-family: \"Urbanist\", sans-serif;\n  font-optical-sizing: auto;\n}\n","@tailwind utilities;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
